
<template>
  <NavTopBar />
  <router-view v-if="isRouterAlive"></router-view>
  <div class="iop">
    <div class="warp6">
      <div class="navHerder">
        <img class="image_1" :src="obj.productImage" alt="" />
      </div>
      <div class="navHerder">
        <div class="left">
          <div class="leftbox">
            订单提交成功，请尽快付款！订单号：{{ obj.orderSn }}
          </div>
          <div class="leftbox">
            请您在提交订单后72小时支付，否则订单会自动取消
          </div>
        </div>
        <div class="right">
          <div class="rightbox">
            应付金额 <span class="yen">{{ obj.orderPrice }}</span
            >元
          </div>
          <div class="rightbox" @click="clean(isShow=false)" v-show='isShow==true' style='cursor:pointer;'> <span>收起详情</span>   </div>
            <div class="rightbox" @click="clean(isShow=true)" v-show='isShow==false' style='cursor:pointer;'><span> 展开详情</span></div>
        </div>
      </div>
      <div class="xian"></div>
      <div class="navHerder"  v-if="isShow">

        <div class="left">
          <div class="leftbox">
            收货地址：{{ obj.receiverAreaInfo }}{{ obj.receiverAddress }}
          </div>
          <div class="leftbox">商品名称：{{ obj.goodsName }}</div>
        </div>

      </div>
      <div class="xian"></div>
      <div class="nav_Herder">Beneficiary Name：Shenzhen Heron Digital Technology Co. Ltd</div>
      <div class="nav_Herder">收款账户：深圳市合衍数字科技有限公司</div>
      <div class="nav_Herder">Bank Name：BANK OF CHINA SHENZHEN FUQIANG SUB-BRANCH</div>
      <div class="nav_Herder">银行名称：中国银行股份有限公司深圳福强支行</div>
      <div class="nav_Herder">Bank Account No.：752374025011</div>
      <div class="nav_Herder">银行账号：752374025011</div>
      <div class="nav_Herder">Bank Swift Code:BKCHCNBJ45A</div>
      <div class="nav_Herder">Bank Address:G/F.,Tims Plaza,No.1008 Jintian Road,Futian District,Shenzhen,China</div>
      <div class="nav_Herder">银行地址：深圳市福田区金田路1008号时代广场首层</div>
      <div class="nav_Herder"></div>
      <div class="payOrder">
        <span class="lable"><i style="color:red">*</i> 支付凭证</span>
        <div class="over">
          <label for="image1" >
            <div class="image1111" v-if="hhh == 1">+</div>
            <div class="image1111" v-if="hhh == 2">
              <img  class="ooimg" :src="Oimage" alt="">
            </div>
          </label>
          <input class="uiop" type="file" id="image1" @change="fileword" />
        </div>
      </div>
      <div class="submit" @click="submit1">确认提交</div>
      <div class="tyu"></div>
    </div>
  </div>
</template>

<script>
import NavTopBar from "../../components/NavTopBar";
import { useRouter } from "vue-router";
import { ref, getCurrentInstance, onMounted } from "vue";
import { ElMessage } from "element-plus";
export default {
  name: "Home",
  components: {
    NavTopBar,
  },
  setup() {
    const isRouterAlive = true;
    const router = useRouter();
    // const route = useRoute();
    const { proxy } = getCurrentInstance();
    const Oimage = ref("");
    const Oimage1 = ref("");
    const hhh = ref(1);
    const obj = ref({});
    const isShow=ref(true)
    const fileword = (e) => {
      //上传凭证
      proxy
        .$post(
          "/v3/oss/common/upload",
          { source: "goods", file: e.target.files[0] },
          "form"
        )
        .then((res) => {
          if (res.state == 200) {
            Oimage.value = res.data.url;
            Oimage1.value = res.data.path;
            hhh.value = 2;
          }
        });
    };
    //支付凭证提交
    const submit1 = () => {
      if(!Oimage.value){
            ElMessage('请上传支付凭证')
      }else{
        proxy
          .$post("/v3/business/front/orderPay/confirmPay", {
            payOrderUrl: Oimage1.value,
            paySn: obj.value.paySn,
          })
          .then((res) => {
            
              if (res.state == 200) {
                setTimeout(function () {
                  router.push({
                    path: "/member/order/list",
                  });
                }, 1500);
              }else{
                  ElMessage(res.msg)
              }
            
        });
      }
    };
    const clean =()=>{
      console.log(111)
    };
    onMounted(() => {
      let iii = localStorage.getItem("item");
      obj.value = JSON.parse(iii);
    });
    return { isRouterAlive, fileword, submit1, Oimage, Oimage1, hhh, obj,isShow,clean };
  },
};
</script>
<style lang="scss"  scoped>
@import "@/style/gopay.scss";
</style>